import WorkflowNodeErrorDomainService from "../WorkflowNodeError/WorkflowNodeError.service";
export default class WorkflowNodeDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate), workflowNodeStatusDate: json.workflowNodeStatusDate && new Date(json.workflowNodeStatusDate), externalStatusDate: json.externalStatusDate && new Date(json.externalStatusDate), nodeErrors: json.nodeErrors.map(WorkflowNodeErrorDomainService.fromJSON) });
    }
}
